module.exports = __webpack_public_path__ + "img/23.05e0e535.jpg";